import React from "react";

import { useDictionary } from "hooks";
import { CAYUSE_TYPES } from "globals/constants";

import Integration from "./Integration";


function HaploCostingTool (props) {
	const dictionary = useDictionary('haploCostingIntegration');

	return <Integration title={dictionary.headline ?? 'Link to Costing Tool'} { ...props }/>;
}

HaploCostingTool.showInPalette = () => true;

HaploCostingTool.paletteInformation = () => ({
	id: "cayuseHaploCostingTool",
	name: "Costing Tool Search",
	type: "cayuseHaploCostingTool",
	group: "sponsoredProject"
});

HaploCostingTool.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-haplo-costing-tool",
		customStencilId: "null"
	},
	type: CAYUSE_TYPES.HAPLO_COSTING,
	cayuseShortLabel: "Costing Tool"
});

HaploCostingTool.initialValue = "{{haploCostingTool}}";


export default HaploCostingTool;
